/**
  Author: Lokesh Arora - lokesh.arora@enabledata.com
  Purpose: Login page
  Date: April 2020
**/

import React, { useState } from 'react';
import {
  Box,
  Paper,
  Grid,
  Dialog,
  DialogContent,
  DialogTitle,
} from '@material-ui/core';

import { withRouter } from 'react-router-dom';
import { /* useStoreState, */ useStoreActions } from 'easy-peasy';
import API from '../../utils/api';
import LoginForm from './components/LoginForm';
import styles from './login.module.scss';
import Header from '../../layout/main/headers/Header';
import Footer from '../../layout/main/footers/Footer';
import { ChangePasswordPage } from '..';
import LocalStorageService from '../../services/localStorage';
const localStorageService = LocalStorageService.getService();
import {loginUserValidationError} from '../../submodule';

const SignInSide = (props) => {
  // const userState = useStoreState((state) => state.login);  
  const userAction = useStoreActions((actions) => actions.login);
  const customizeAction = useStoreActions((actions) => actions.customize);
  const comonAction = useStoreActions((actions) => actions.common);
  const [isLoading, setIsLoading] = useState(false);
  const [pwdChange, setPwdChange] = React.useState(false);
  // const [loginError, setLoginError] = React.useState('');

  const hideModalWindow_pwdChange = () => {
    setPwdChange(false);
  };

  /**
   * On Login Page submit, trigger a API call
   * @param {object} values username and password
   */
  const handleLogin = (values) => {
    setIsLoading(true);
    userAction
      .authenticate(values)
      .then((response) => {
        setIsLoading(false);
        if (response && response.data && response.data.success) {
          if (
            response.data.data &&
            response.data.data.ChallengeName === 'NEW_PASSWORD_REQUIRED'
          ) {
            localStorageService.setLoginInfo({
              accessToken: response.data.data.AuthenticationResult.AccessToken,
              refreshToken: null,
              username: values.username,
            });
            userAction.setUserName(values.username);
            userAction.setForceChangePassword(true);

            //Set access token to API instance
            API.defaults.headers[
              'Authorization'
            ] = `Bearer ${response.data.data.AuthenticationResult.AccessToken}`;
            userAction.getUserInfo().then((responseData) => {
              customizeAction.getConfigData();
              if (!pwdChange) setPwdChange(true);
            });
          } else {
            localStorageService.setLoginInfo({
              accessToken: response.data.data.AuthenticationResult.AccessToken,
              refreshToken:
                response.data.data.AuthenticationResult.RefreshToken,
              clientID: response.data.data.client_id,
              username: values.username,
              tokenTimestamp: Date.now()
            });
            userAction.setUserName(values.username);
            userAction.getUserInfo();

            //Set access token to API instance
            API.defaults.headers[
              'Authorization'
            ] = `Bearer ${response.data.data.AuthenticationResult.AccessToken}`;
            // customizeAction.getConfigData()
            customizeAction.getConfigData().then(function (responseData) {
              // customizeAction.setConfigData(responseData.data.data.config);
              props.history.push('/');
            });
          }
        }
      })
      .catch((error) => {
        setIsLoading(false);
        if (error.response) {
          comonAction.setSubmitSnackbar(loginUserValidationError(error.response));
        }
      });
  };

  React.useEffect(() => {
    localStorage.removeItem('fontColor');
  }, []);

  // React.useEffect(() => {}, [userState]);

  return (
    <Grid container component="main" style={{ height: '100vh', overflowY: 'scroll' }}>
      <Grid item xs={12} component={Paper} square>
        <Header />
        <Grid
          container
          alignItems="center"
          justifyContent="center"
          style={{ minHeight: 'calc(100% - 115px)' }}
        >
          <Grid item xs={12} md={6} lg={6}>
            <Box className={styles['login-wrapper']}>
              <Box
                data-testid="header-text"
                component="h2"
                sx={{ m: 0, fontWeight: 'bold', textAlign: 'center' }}
              >
                Login
              </Box>
              <LoginForm handleLogin={handleLogin} isLoading={isLoading} />
            </Box>
            <Dialog
              open={pwdChange}
              fullWidth
              maxWidth="xs"
              onClose={hideModalWindow_pwdChange}
              PaperProps={{
                style: { borderRadius: 20 }
              }}
            >
              <DialogTitle style={{margin: '0px 16px', padding: '24px 24px 0px'}} onClose={hideModalWindow_pwdChange}>
                Change Password
              </DialogTitle>
              <DialogContent>
                <ChangePasswordPage />
              </DialogContent>
            </Dialog>
          </Grid>
        </Grid>
        <Footer />
      </Grid>
    </Grid>
  );
};

export default withRouter(SignInSide);
